/**
* Adding Shared Resources File Names (mod-form, mod-utils, mod-analytics) to Heap Session
*/
export function addSharedResourceFileNamesToHeap() {
	const resourceNameAndFilePattern = {
		'mod-form': 'form/homeowner',
		'mod-utils': 'mod-utils/modutils',
		'mod-alytics': 'mod-alytics/modalytics'
	};

	document.querySelectorAll('script').forEach(script => {
		const src = script.src;
		if (src) {
			for (const key in resourceNameAndFilePattern) { // eslint-disable-line guard-for-in
				const pattern = resourceNameAndFilePattern[key];
				if (src.includes(pattern)) {
					window.Modalytics.heap('addEventProperties', {
						[key]: src.split('/').pop()
					});
				}
			}
		}
	});
}